/**
 * B819 — the guest pages (/me, /memberships) wear the tenant's channel theme
 * exactly as the hosted storefront does (Pathik, 2026-10-13: "if we are going
 * to keep it on storefront we need storefront personalized for tenant" — the
 * zoo's /me painted the kit's default blue). Same sink, same vars, same
 * session-storage recall for the first paint; nothing here is a second
 * theming path. Pure of React: the apps call it from an effect.
 */
import { applyChannelTheme, brandSheetFor, createThemeSink, recallChannelTheme, rememberChannelTheme, type ChannelThemeLike, type ThemeSink } from "./theme.js";

let sink: ThemeSink | undefined;

function sinkFor(doc: Document): ThemeSink {
  sink ??= createThemeSink(doc.documentElement.style, doc.documentElement, brandSheetFor(doc));
  return sink;
}

/** The first paint, from what the last visit remembered (the hosted page's own recall). */
export function paintRememberedTheme(doc: Document = document): void {
  let storage: Storage | null;
  try {
    storage = window.sessionStorage;
  } catch {
    storage = null;
  }
  const remembered = recallChannelTheme(storage);
  if (remembered !== undefined) applyChannelTheme(sinkFor(doc), remembered);
}

/** The guest door answered: paint its theme and remember it for the next load. */
export function paintVenueTheme(theme: ChannelThemeLike | undefined, doc: Document = document): void {
  if (theme === undefined) return;
  applyChannelTheme(sinkFor(doc), theme);
  try {
    rememberChannelTheme(window.sessionStorage, theme);
  } catch {
    /* memory-only visits paint again next time */
  }
}
